import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Grid } from '@mui/material';
import useMoney from '../../hooks/useMoney';
import LangEnum from '../../lang/LangEnum';
import { ActiveOrderTestIds } from '../../utils/testIds/ActiveOrder.testIds';
import { useTranslation } from '../translation/TranslationContext';
import { useOrderBookStyles } from './styles/OrderBookStyles';
import { ListOrdersV2Output } from './types/orderBook.types';

type OrderBookOptionRendererProps = {
  order: ListOrdersV2Output;
};

const OrderBookOptionRenderer = ({ order }: OrderBookOptionRendererProps) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();
  const { classes } = useOrderBookStyles();

  return (
    <Grid
      container
      sx={{ width: '100%' }}
      test-id={`${ActiveOrderTestIds.ORDER_BOOK_ORDERS_AUTOCOMPLETE_OPTION}-${order.code}`}
    >
      <Grid className={classes.item} size={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflow: 'hidden',
            maxWidth: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              overflow: 'hidden',
              minWidth: 0,
              marginRight: 2,
            }}
          >
            <Typography noWrap variant="body2" color="textPrimary">
              {order.customer?.commercialName ||
                translate(LangEnum.ORDER_BOOK_ORDER_WITHOUT_CUSTOMER)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexShrink: 0,
            }}
          >
            <Typography
              noWrap
              variant="body2"
              sx={(theme) => ({
                fontWeight: theme.typography.fontWeightBold,
                wordBreak: 'normal',
              })}
            >
              {`pedido ${order.code}`}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid className={classes.item} size={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            overflow: 'hidden',
            maxWidth: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              overflow: 'hidden',
              minWidth: 0,
              marginRight: 2,
            }}
          >
            <Typography noWrap variant="caption" color="textSecondary">
              {order.customer?.companyName || translate(LangEnum.ORDER_BOOK_ORDER_WITHOUT_CUSTOMER)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexShrink: 0,
            }}
          >
            <Typography noWrap variant="caption" color="textSecondary">
              {formatMoney(order.subTotal)}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrderBookOptionRenderer;
